import { LoadingOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import styled from 'styled-components';

import { QuestionMarkSvg } from '../../../assets/icons';
import useRouterMatch from '../../../hooks/useRouterMatch';
import useWorkSpace from '../../../hooks/useWorkSpace';
import { Input } from '../../_atoms/_Input';
import { Button } from '../../_atoms/Button';
import { Center } from '../../_atoms/Center';
import { IconWrapper } from '../../_atoms/IconWrapper';
import BaseModal from '../../_molecules/BaseModal';

const CreateTeam = ({ visible, onDone }: { visible: boolean; onDone: () => void }) => {
  const { tenantId, router } = useRouterMatch();
  const { createWorkspace, isCreatingWorkspace } = useWorkSpace();
  const { t } = useTranslate();
  const [missingWorkspaceName, setMissingWorkspaceName] = useState<string | undefined>();
  const [workspaceNameInput, setWorkspaceNameInput] = useState('');
  const handleCreateWorkspace = () => {
    if (workspaceNameInput.length === 0) {
      setMissingWorkspaceName(t('Please enter a name'));
      return;
    }
    if (!isCreatingWorkspace) {
      createWorkspace({
        workspaceConfig: {
          title: workspaceNameInput,
        },
        onSuccessFunction: data => {
          onDone();
          router.push(`/${tenantId}/workspace/${data.id}`);
        },
      });
    }
  };

  return (
    <BaseModal visible={visible} onCancel={onDone}>
      <CreateWorkspaceModalContainer>
        <CreateWorkspaceModalTitle>
          {t('Create School Library')}
        </CreateWorkspaceModalTitle>
        <p>
          {t(
            'Work together with your team in a shared school library. Create shared lesson templates and collaborate with others.',
          )}
        </p>
        <p>
          <a
            target="__blank"
            rel="noopener noreferrer"
            href="https://curipod.com/help/What is a workspace-2ea7e17e100944c3bd8eb8d74862081e"
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              <IconWrapper height="20px" width="20px" style={{ marginRight: '10px' }}>
                <QuestionMarkSvg />
              </IconWrapper>{' '}
              {t('Learn more about school libraries')}
            </span>
          </a>
        </p>
        <CreateWorkspaceModalSubTitle>
          {t('School Library Name')}
        </CreateWorkspaceModalSubTitle>
        <Input
          style={{ width: '100%', marginBottom: '10px' }}
          placeholder={t('Enter a name for your school library')}
          value={workspaceNameInput}
          maxLength={30}
          error={missingWorkspaceName}
          onPressEnter={handleCreateWorkspace}
          onChange={e => {
            setMissingWorkspaceName(undefined);
            setWorkspaceNameInput(e.target.value);
          }}
        />
        <Center>
          <Button disabled={isCreatingWorkspace} onClick={handleCreateWorkspace}>
            {isCreatingWorkspace && <LoadingOutlined />}
            {isCreatingWorkspace && t('Creating', 'Creating')}
            {!isCreatingWorkspace && t('Create', 'Create')}
          </Button>
        </Center>
      </CreateWorkspaceModalContainer>
    </BaseModal>
  );
};

export default CreateTeam;

const CreateWorkspaceModalTitle = styled.h1`
  width: 100%;
  text-align: left !important;
`;

const CreateWorkspaceModalSubTitle = styled.h2`
  width: 100%;
  text-align: left !important;
  font-weight: bold;
`;

const CreateWorkspaceModalContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: flex-start;
  font-weight: bold;
`;
